import { InjectionToken } from '@angular/core';

export const PACKAGE_JSON = new InjectionToken<any>('PACKAGE_JSON');
